// Slide decks associated with Software Systems Capstone (SSC) sprint 4
import { xyz_n_1of4 } from './SL00000Sprint00TTR'

import { list49200Sprint03 } from '../ActivityLists/AL49200Sprint03'
import { list49200Sprint04 } from '../ActivityLists/AL49200Sprint04'

const sprint = 4
const activityList = () => { return list49200Sprint04(sprint) }
const activityListPrevious = () => { return list49200Sprint03(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

const ssc_4_1of4 = () => { return xyz_n_1of4(null, null, sprintAndActivityLists, null) }

export const ssc_4_slidedeckTTR = [ ssc_4_1of4, null, null, null ]